export const PageTable = {
  maps: { title: 'JE 配布マップ一覧', path: '/' },
  color: { title: 'カラーツール', path: '/color' },
  rule: { title: 'ルール一括設定', path: '/rule' },
};
